module.exports = __webpack_public_path__ + "img/img3.72f06e81.png";